export default function registerSelfRegistrationScreen(Alpine) {
    Alpine.data('selfRegistrationScreen', () => ({
        handleSubmit() {
            this.$refs.registrationForm?.requestSubmit();
        },

        onRegistrationSubmit() {
            const btn = this.$refs.submitButton;
            if (btn) {
                btn.disabled = true;
                const processing = btn.dataset.processingText;
                if (processing) {
                    btn.textContent = processing;
                }
            }
        },
    }));
}
